import React                      from 'react'
import { observable }             from 'mobx'
import { Observer }               from 'mobx-react'
import { Input }                  from 'antd'

import { TEXT }                   from '../00_assets'
import { FormElement }            from '../10_ui'


export class MResetPass
{
  @observable email: string = '' ;
  

  on_email_change = ( ev: React.ChangeEvent< HTMLInputElement > ) =>
    this.email = ev.target.value ;

  get fields ( )
  {
    return { email: this.email } ;
  }
}


export const ResetPassEditor: React.FC< { model: MResetPass } > = ( props ) =>
<Observer render={ ( ) => 
{ 
  const model = props.model ;

  return <FormElement label={ TEXT.UI_EMAIL }>
           <Input
             className="text-right w-100"
             min={1} 
             value={ model.email }
             onChange={ model.on_email_change }
           />
         </FormElement> ;
} } /> ;